import axios from "axios";
import SERVER from '@/API/url';

const FileStore = {
    namespaced: true,
    state: {
        
    },
    getters: {

    },
    mutations: {

    },
    actions: {

        // 파일 업로드
        FileUpload: ({commit}, params) => { 
            
            let formData = new FormData();
			formData.append('file', params.file, params.filename);
			formData.append('path', params.path);

            return new Promise((resolve, reject) => {
                axios.post(SERVER.URL + '/api/File/upload?path='+params.path, formData,
                { 
                    headers: {
                        ...SERVER.HEADERS,
                        'Content-Type': 'multipart/form-data',
                    }
                }
                ).then(res => {
                    // console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },
    }
}

export default FileStore